import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

// Load form configuration from YAML
const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig

export const ShipperNameEnum = z.enum(["ups", "usps", "fedex"])

export const ShipDeviceFormSchema = z.object({
  // Optional to match the backend: upsertDeviceProcurementInfo requires only deviceNumber
  // (auto-filled). Empty select value ('') is treated as "not set".
  shipperName: z.preprocess(
    (v) => (v === '' || v == null ? undefined : v),
    ShipperNameEnum.optional(),
  ),
  deviceShippingDate: z.string().optional().or(z.literal('')),
  // Keep inline form validation aligned with API contract (max 64)
  deviceShippingTrackingNumber: z.string().max(64, 'Tracking number cannot exceed 64 characters').optional(),
  deviceShippedToAddress: z.string().optional().or(z.literal('')),
})

export type ShipDeviceFormData = z.infer<typeof ShipDeviceFormSchema>

export function transformToApiRequest(formData: ShipDeviceFormData, deviceNumber: number, deviceProcurementInfoNumber?: number) {
  return {
    device: {
      deviceNumber,
      deviceStatus: "shipped",
    },
    procurementInfo: {
      ...(deviceProcurementInfoNumber ? { deviceProcurementInfoNumber } : {}),
      deviceNumber,
      ...(formData.shipperName ? { shipperName: formData.shipperName } : {}),
      ...(formData.deviceShippingDate
        ? { deviceShippingDate: new Date(String(formData.deviceShippingDate)).getTime() / 1000 }
        : {}),
      ...(formData.deviceShippingTrackingNumber !== undefined && formData.deviceShippingTrackingNumber !== null && formData.deviceShippingTrackingNumber !== ''
        ? { deviceShippingTrackingNumber: formData.deviceShippingTrackingNumber }
        : {}),
      ...((() => {
        const n = parseInt(formData.deviceShippedToAddress ?? '', 10)
        return Number.isFinite(n) && n >= 1000000000 ? { deviceShippedToAddressNumber: n } : {}
      })()),
      deviceProcurementStatus: "shipped",
    },
  }
}
